import { Text, fontWeightEnum, textVariantsEnum } from '@/components/Text';
import React from 'react';
import styles from './RegularizationRequests.module.scss';
import { Button, buttonVariants } from '@/components/Button';
export const RegularizationRequestsModal = ({ onAccept, onDecline }) => {
  return (
    <div className={styles.regularizationRequestsModal}>
      <Text
        variant={textVariantsEnum.Text_13}
        fontWeight={fontWeightEnum.Medium}
      >
        Process Form
      </Text>
      <div className={styles.regularizationRequestsModalContent}>
        <Text
          variant={textVariantsEnum.Text_13}
          fontWeight={fontWeightEnum.Medium}
        >
          Please accept or decline this application
        </Text>
        <Text
          variant={textVariantsEnum.Text_13}
          fontWeight={fontWeightEnum.Medium}
        >
          Note:- Request can not be update and delete after proceed..
        </Text>
      </div>
      <div className={styles.regularizationRequestsModalButtons}>
        <Button
          variant={buttonVariants.primary}
          onClick={onAccept}
          text="Accept"
        />
        <Button
          variant={buttonVariants.red}
          onClick={onDecline}
          text="Decline"
        />
      </div>
    </div>
  );
};
